{
  "completed": "Completato: ",
  "current": "Attuale: ",
  "notCompleted": "Non completato: ",
  "steplist": "Elenco dei passaggi"
}
